import { Alert, Button, formatBRL, formatDate } from '@alicerce/ui';
import { useState } from 'react';

export interface ChargeView {
  invoiceId?: string;
  status: string;
  amountCents: number;
  method: string;
  pixQrCode: string | null;
  pixCopyPaste: string | null;
  boletoUrl: string | null;
  paymentUrl: string | null;
  dueDate: string;
}

/** Pix (QR code e copia e cola), boleto ou link de pagamento de uma cobrança. */
export function PaymentInstructions({ charge, title, description }: { charge: ChargeView; title?: string; description?: string }) {
  const [copied, setCopied] = useState(false);
  return (
    <div className="space-y-3 rounded-lg border border-line p-4">
      {title && <p className="font-medium">{title}</p>}
      <p className="text-sm text-muted">
        {formatBRL(charge.amountCents)} · vence em {formatDate(charge.dueDate)}
        {description ? `. ${description}` : ''}
      </p>
      {charge.pixQrCode && (
        <img
          src={charge.pixQrCode.startsWith('data:') ? charge.pixQrCode : `data:image/png;base64,${charge.pixQrCode}`}
          alt="QR code do Pix"
          className="size-48 rounded border border-line"
        />
      )}
      {charge.pixCopyPaste && (
        <div className="flex flex-wrap items-center gap-2">
          <code className="max-w-full flex-1 truncate rounded bg-canvas px-2 py-1 text-xs">{charge.pixCopyPaste}</code>
          <Button
            size="sm"
            variant="secondary"
            onClick={async () => {
              try {
                await navigator.clipboard.writeText(charge.pixCopyPaste!);
                setCopied(true);
              } catch {
                setCopied(false);
              }
            }}
          >
            {copied ? 'Copiado' : 'Copiar código Pix'}
          </Button>
        </div>
      )}
      {(charge.boletoUrl ?? charge.paymentUrl) && (
        <a className="text-sm font-medium text-brand-700 hover:underline" href={(charge.boletoUrl ?? charge.paymentUrl)!} target="_blank" rel="noreferrer">
          Abrir {charge.boletoUrl ? 'boleto' : 'página de pagamento'}
        </a>
      )}
      {charge.status === 'PAID' && <Alert tone="success">Pagamento confirmado.</Alert>}
    </div>
  );
}
